import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(advancedFormat)
dayjs.extend(localizedFormat)
dayjs.extend(timezone)
dayjs.extend(utc)

const getFormattedDate = (date: string, format: string, timezone?: string) => {
  const dateObj = dayjs(date).tz(timezone)
  return dateObj.format(format)
}

export default {
  getFormattedDate,
}
